import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {Field, reduxForm} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import {RESOURCES as locationResources} from '../fuseLocationsResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A form containing a Virtualized Select component
 *
 */
class LocationFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
            locationsList: [],
            selectedLocation: null,
        };
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
    }

    componentDidMount() {
        this.fetchLocationsData();
    }

    /* API Calls ------------------------------ */

    /**
     * Get list of Locations for filter
     */
    fetchLocationsData() {
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: "id", order: "ASC"}
        };
        const resource = locationResources.Locations.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        // Retrieve the data and assign results to the Select choices
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                const locations = this.processLocationsData(result.data.payload);
                this.setState({
                    errorMessage: null,
                    locationsList: locations
                }, () => {
                    if (this.props.onLocationsLoaded !== null) {
                        this.props.onLocationsLoaded(locations);
                    }
                });
            }
        }).catch((error) => {
            let message = 'Sorry, there was an error retrieving Locations.';
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
                message = 'Sorry, there was no response retrieving Locations.';
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                errorMessage: message
            });
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Format Location display names for filter
     *
     * @param list
     * @return {Array}
     */
    processLocationsData(list) {
        let locationsList = [];
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (item) {
                    const id = (item.id) ? item.id.toString() : '';
                    const name = (item.name) ? ' - ' + item.name.toString() : '';
                    const city = (item.city) ? ' - ' + item.city.toString() : '';
                    const state = (item.state) ? ' - ' + item.state.toString() : '';
                    item.filter_name = id + name + city + state;
                    locationsList.push(item);
                }
            }
        }
        return locationsList;
    }

    /**
     * Handle selection event for Location
     *
     * @param event
     * @param index
     * @param value
     */
    handleLocationSelect(event, index, value) {
        if (index && index !== value) {
            // Extract the full Location object from the selected location_id
            const locationObj = this.state.locationsList.find(n => n.id === index);
            if (locationObj) {
                this.setState({
                    selectedLocation: locationObj,
                }, () => {
                    if (this.props.selectionType === 'object') {
                        this.props.onSelectLocation('location', locationObj);
                    }
                    if (this.props.selectionType === 'id') {
                        this.props.onSelectLocation('location', locationObj.id.toString());
                    }
                });
            }
        }
    }

    render() {
        const {
            label
        } = this.props;

        const {
            errorMessage,
            locationsList
        } = this.state;

        const styles = {
            break: {display: 'block', width: '100%', height: 0, border: 'none', margin: 0},
        };

        return (
            <form>
                <div className="list-filter">
                    <Field name="location_id"
                           component={VirtualizedSelectInput}
                           choices={locationsList}
                           label={label}
                           optionText="filter_name"
                           optionValue="id"
                           onChange={this.handleLocationSelect}
                           allowEmpty
                           options={{
                               className: "full-width has-label",
                               clearable: true,
                               placeholder: label
                           }}
                    />
                    <hr style={styles.break}/>
                    {/* Error and Messaging */}
                    {errorMessage &&
                        <div className="error">
                            <p>{errorMessage}</p>
                        </div>
                    }
                </div>
            </form>
        );
    }
}

LocationFilter.propTypes = {
    label: PropTypes.string,
    onLocationsLoaded: PropTypes.func,
    onSelectLocation: PropTypes.func,
    selectionType: PropTypes.string
};

LocationFilter.defaultProps = {
    label: 'Select a Location:',
    onLocationsLoaded: null,
    selectionType: 'object'
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'filterForm',
        enableReinitialize: true,
    })
);

export default enhance(LocationFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/LocationFilter.js